<template>
  <div class="error-page">
    <div>
      <div class="error-code">4<span>0</span>3</div>
      <div class="error-desc">当前岗位无此权限，请联系管理员</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="less">
.error-page {
  width: 100vw;
  height: 100vh;
  background: #f3f3f3;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.error-code {
  line-height: 1;
  font-size: 250px;
  font-weight: bolder;
  color: #777;
}
.error-code span {
  color: #777;
}
.error-desc {
  font-size: 30px;
  color: #777;
  text-align: center;
}
</style>
